import { render, staticRenderFns } from "./Haskell.vue?vue&type=template&id=a3f82244&scoped=true&lang=html&"
import script from "./Haskell.vue?vue&type=script&lang=js&"
export * from "./Haskell.vue?vue&type=script&lang=js&"
import style0 from "./Haskell.vue?vue&type=style&index=0&id=a3f82244&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f82244",
  null
  
)

export default component.exports